import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { StyleSheet, View, TouchableWithoutFeedback, Animated } from 'react-native';
import { getPostion, animatedTo, parseSideSpace } from "./utils";
const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    flexDirection: 'row',
    overflow: 'hidden'
  }
});
const MaskDom = /*#__PURE__*/forwardRef((props, ref) => {
  var _useRef;
  const {
    duration = 150,
    showMask = true,
    onPress,
    contentPosition = 'center',
    children,
    customStyle,
    opacity: targetOpacity = 1,
    sideSpace = 0,
    afterShow,
    afterClose,
    scalable = true,
    onAnimatedEnd
  } = props;
  const {
    backgroundColor = '#0000007a'
  } = customStyle || {};
  const opacity = (_useRef = useRef(new Animated.Value(0))) === null || _useRef === void 0 ? void 0 : _useRef.current;
  const position = getPostion(contentPosition);
  const handleClose = () => {
    animatedTo({
      target: opacity,
      toValue: 0,
      duration,
      fn: () => {
        onAnimatedEnd && onAnimatedEnd();
        afterClose && afterClose();
      }
    });
  };
  useImperativeHandle(ref, () => ({
    close: handleClose
  }));
  const handlePress = () => {
    onPress && onPress();
  };
  useEffect(() => {
    animatedTo({
      target: opacity,
      toValue: targetOpacity,
      duration,
      fn: afterShow
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: [StyleSheet.absoluteFill, styles.wrap, position, parseSideSpace({
      sideSpace,
      scalable
    })],
    pointerEvents: showMask ? 'auto' : 'box-none',
    testID: "mask-wrap"
  }, showMask ? /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: handlePress,
    testID: "mask-dom"
  }, /*#__PURE__*/React.createElement(Animated.View, {
    style: [StyleSheet.absoluteFill, {
      backgroundColor
    }, {
      opacity
    }]
  })) : null, children);
});
export default MaskDom;